import { Typography } from '@mui/material';

export interface Address {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  zip: string;
}

export const AddressFormatter = {
  toShort: (address: Address): string => {
    if (!address) {
      return '';
    }
    const addressParts = [
      address.line1,
      address.line2,
      address.city,
      address.state,
    ].filter(part => !!part);

    return addressParts.join(' ');
  },
  toLong: (address: Address): string => {
    if (!address) {
      return '';
    }
    const addressParts = [
      address.line1,
      address.line2,
      address.city,
      [address.state, address.zip].filter(p => p).join(' '),
    ].filter(part => !!part);

    return addressParts.join(', ');
  },
};

export const AddressLabel = ({ address }) => {
  return (
    <Typography variant="bodyMedium">
      {address.line1}, {address.line2 && <>{address.line2}</>} {address.city},{' '}
      {address.state} {address.zip}
    </Typography>
  );
};
